__turbopack_context__.v({
  "trainingOrganizationsWrapper": "pZlR2a_trainingOrganizationsWrapper",
});
